import pdfMake from "pdfmake/build/pdfmake";

import pdfFonts from "pdfmake/build/vfs_fonts";

import header from '../../../Auth/Image/logoblack.png'

import { BorderBottom } from "@mui/icons-material";

import { px } from "framer-motion";

// ✅ NEW: Header/Footer utility (QuotePdf jaisa)
import {
  loadPdfImages,
  getPdfHeader,
  getPdfFooter,
  PDF_PAGE_MARGINS,
} from "../../../utility/pdfUtils";

// ✅ NEW: Company profile se dynamic data
import { getCompanyProfile } from "../../../Services/Services";

// fonts load karna jaruri hai

pdfMake.vfs = pdfFonts.vfs;

export const handlePrint = async (po) => {
  console.log(po);

  // ✅ NEW: Header/Footer images load (QuotePdf jaisa)
  const { headerBase64, footerBase64 } = await loadPdfImages();

  // ✅ NEW: Company profile fetch - NULL SAFE
  let company = null;
  try {
    company = await getCompanyProfile();
  } catch (profileError) {
    console.warn(
      "Company profile fetch failed, continuing without it:",
      profileError
    );
  }

  const terms = Array.isArray(po.terms_conditions) ? po.terms_conditions : [];

  const stored = localStorage.getItem("selectedDivision");

  const division = JSON.parse(stored);

  const termsTableBody = [

    [

      { text: "ID", bold: true },

      { text: "Point", bold: true },

      { text: "Description", bold: true },

    ],

    ...terms.map((term, index) => [

      { text: `${index + 1}`, alignment: "center" },

      { text: term.key || "", alignment: "left" },

      { text: term.value || "", alignment: "left" },

    ]),

  ];

  const totalAmount = po.items

    .reduce((sum, item) => {

      const quantity = parseFloat(item.quantity);

      const unitPrice = parseFloat(item.rate);

      const isValid = !isNaN(quantity) && !isNaN(unitPrice);

      return sum + (isValid ? quantity * unitPrice : 0);

    }, 0)

    .toFixed(2);

  const docDefinition = {

    // ✅ NEW: QuotePdf jaisa pageMargins
    pageMargins: PDF_PAGE_MARGINS,

    defaultStyle: {

      fontSize: 9,

    },

    // ✅ NEW: Header/Footer utility se (QuotePdf jaisa)
    header: getPdfHeader(headerBase64),

    footer: getPdfFooter(footerBase64, false),

    content: [

      {

        text: "PURCHASE ORDER",

        alignment: "center",

        style: "poTitle",

        margin: [0, 0, 0, 10],

      },

      {

        table: {

          widths: ["50%", "50%"],

          body: [

            [

              {

                stack: [

                  {

                    text: "Details of Recipient (Billed to)",

                    bold: true,

                    fontSize: 10,

                    margin: [0, 0, 0, 2],

                    decoration: "underline",

                  },

                  {

                    text: [

                      { text: "Name        : ", bold: true },

                      po.billed_to_name || "CRANOIST MHE PVT LDT>",

                    ],

                  },

                  {

                    text: [

                      { text: "Address    : ", bold: true },

                      po.billed_to_address || "Borai Rashmada Chhattishgarh 491001",

                    ],

                  },

                  {

                    columns: [

                      {

                        text: [

                          { text: "State Name : ", bold: true },

                          po.billed_to_state_name || "Chattisgarh",

                        ],

                      },

                      // {

                      //   text: [

                      //     { text: "State Code : ", bold: true },

                      //     po.billed_to_state_code || "22",

                      //   ],

                      //   alignment: "right",

                      // },

                    ],

                  },

                  {

                    text: [

                      { text: "GSTIN       : ", bold: true },

                      po.billed_to_gst_no || "22AAHFK2314C1Z4",

                    ],

                  },

                  {

                    text: [

                      { text: "PAN No.     : ", bold: true },

                      po.billed_to_pan_no || "AAHFK2314C",

                    ],

                  },

                  {

                    text: [

                      { text: "Contact     : ", bold: true },

                      po.billed_to_contact || "9302125991",

                    ],

                  },

                ],

                margin: [0, 2],

              },

              {

                stack: [

                  {

                    columns: [

                      { width: 80, text: "PO Number", bold: true },

                      { width: 10, text: ":", bold: true },

                      { width: "*", text: po.po_number || "-", bold: true },

                    ],

                  },

                  {

                    columns: [

                      { width: 80, text: "Date", bold: true },

                      { width: 10, text: ":", bold: true },

                      {

                        width: "*",

                        text: new Date(po.created_at).toLocaleDateString(),

                      },

                    ],

                  },

                  // {

                  //   columns: [

                  //     { width: 80, text: "Division", bold: true },

                  //     { width: 10, text: ":", bold: true },

                  //     { width: "*", text: po.division_name || "Main" }, // Adjust variable name

                  //   ],

                  // },

                  { text: " ", fontSize: 4 }, // Spacer

                  {

                    canvas: [

                      {

                        type: "line",

                        x1: 0,

                        y1: 0,

                        x2: 250,

                        y2: 0,

                        lineWidth: 0.5,

                        lineColor: "gray",

                      },

                    ],

                  },

                  { text: " ", fontSize: 4 }, // Spacer

                  // {

                  //   text: [

                  //     { text: "PARTY REF. NO. : ", bold: true },

                  //     po.reference_no || "No Reference",

                  //   ],

                  // },

                  // {

                  //   text: [

                  //     { text: "INDENT NO.  : ", bold: true },

                  //     po.indent_no || "Without Indent PO",

                  //   ],

                  // },

                ],

                margin: [0, 2],

              },

            ],

            [

              // LEFT SIDE – Supplier Identity

              {

                stack: [

                  {

                    text: "Details of Supplier (Billed from)",

                    bold: true,

                    fontSize: 10,

                    margin: [0, 2, 0, 2],

                    decoration: "underline",

                  },

                  {

                    text: [

                      { text: "Name        : ", bold: true },

                      po.supplier_name || "N/A",

                    ],

                  },

                  {

                    text: [

                      { text: "Address    : ", bold: true },

                      po.billing_address || "N/A",

                    ],

                  },

                  {

                    columns: [

                      {

                        text: [

                          { text: "State Name : ", bold: true },

                          po.supplier_state || "Not Defined",

                        ],

                      },

                      // {

                      //   text: [

                      //     { text: "State Code : ", bold: true },

                      //     po.supplier_state_code || "Not Defined",

                      //   ],

                      //   alignment: "right",

                      // },

                    ],

                  },

                ],

                margin: [0, 0, 0, 10],

              },

              // RIGHT SIDE – Tax & Contact

              {

                stack: [

                  { text: " ", margin: [0, 2] }, // aligns with heading

                  {

                    text: [

                      { text: "GSTIN       : ", bold: true },

                      po.billing_gst || "-",

                    ],

                  },

                  {

                    text: [

                      { text: "PAN No.     : ", bold: true },

                      po.billing_pan || "-",

                    ],

                  },

                  {

                    text: [

                      { text: "Contact     : ", bold: true },

                      po.billing_contact || "-",

                    ],

                  },

                ],

                margin: [0, 2],

              },

            ],

          ],

        },

        layout: {

          hLineWidth: () => 0.5,

          vLineWidth: () => 0.5,

          hLineColor: () => "#000000",

          vLineColor: () => "#000000",

        },

        margin: [0, 0, 0, 10],

      },

      {

        text: "\nSub:",

        bold: true,

      },

      {

        table: {

          widths: ["auto", "*", "*", "*", "auto", "auto", "auto", "auto"], widths: ["auto", "*", "*", "auto", "*", "auto", "auto", "auto", "auto"], // ✅ 9 columns (8 se 9)

          body: [

            [

              { text: "S NO.", bold: true, alignment: "center" },

              { text: "ITEM", bold: true, alignment: "center" },

              { text: "PRODUCT TYPE", bold: true, alignment: "center" },
              { text: "RESERVE QTY", bold: true, alignment: "center" },   // <--- NEW

              { text: "UNIT", bold: true, alignment: "center" },

              { text: "DESCRIPTION", bold: true, alignment: "center" },

              { text: "QUANTITY", bold: true },

              { text: "UNIT PRICE", bold: true },

              { text: "AMOUNT", bold: true },

            ],

            ...po.items.map((item, i) => {

              const quantity = parseFloat(item.quantity);

              const unitPrice = parseFloat(item.rate);

              const isValid = !isNaN(quantity) && !isNaN(unitPrice);

              const total = isValid ? (quantity * unitPrice).toFixed(2) : "-";

              return [

                { text: i + 1, alignment: "center" },

                { text: item.item_name || "-", alignment: "center" },

                { text: item.size_name || "-", alignment: "center" },
                { text: item.reserve_qty || 0, alignment: "center" },

                { text: item.unit_name || "-", alignment: "center" },

                { text: item.description || "-", alignment: "center" },

                {

                  text: !isNaN(quantity) ? quantity : "-",

                  alignment: "center",

                },

                {

                  text: !isNaN(unitPrice) ? unitPrice : "-",

                  alignment: "center",

                },

                { text: item.amount || "-", alignment: "center" },

              ];

            }),

            [

              { colSpan: 8, text: "TOTAL", alignment: "right", bold: true }, // ✅ colSpan 7 se 8

              "",

              "",

              "",

              "",

              "",

              "",
              "",

              totalAmount, // 9th column

            ],

          ],

        },

        layout: {

          hLineWidth: () => 0.5,

          vLineWidth: () => 0.5,

          hLineColor: () => "#000000",

          vLineColor: () => "#000000",

        },

        margin: [0, 0, 0, 2],

      },

      {

        text: {

          text: "Terms & Conditions",

          bold: "true",

          decoration: "underline",

        },

        style: "termsTitle",

        margin: [0, 2, 0, 0],

      },

      {

        text: "Purchase Order is subject to following the terms and conditions:-",

        style: "termsTitle",

        margin: [0, 2, 0, 4],

      },

      {

        table: {

          headerRows: 1,

          // widths: [20, 130, "*"],

          widths: ["auto", "*", "*"],

          body: termsTableBody,

        },

        layout: {

          hLineWidth: () => 0.5,

          vLineWidth: () => 0.5,

          hLineColor: () => "#000000",

          vLineColor: () => "#000000",

        },

      },

      {

        text: "\nNote: Full quantity should be supplied without any shortage.",

        italics: true,

        fontSize: 8,

      },

      {

        margin: [400, 15, 0, 0], // [left, top, right, bottom]

        alignment: "left",

        stack: [

          // ✅ NEW: Company name company profile se (fallback: purana naam)
          { text: `For ${company?.company_name || "CRANOIST MHE PVT. LTD."}`, bold: true, margin: [0, 0, 0, 20] },

          {

            canvas: [

              { type: "line", x1: 0, y1: 0, x2: 100, y2: 0, lineWidth: 0.5 },

            ],

          },

          { text: "Auth. Signatory", margin: [15, 5, 0, 0] }, // Label below the line

        ],

      },

    ],

    styles: {

      poTitle: {

        fontSize: 12,

        bold: true,

        decoration: "underline",

      },

      termsTitle: {

        fontSize: 10,

      },

    },

  };

  pdfMake.createPdf(docDefinition).open();

};
